import { formatarData } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";

const TIPO_SOLICITACAO_LABELS = {
    NOVO_CADASTRO: "Novo Cadastro",
    ALTERACAO_CADASTRO: "Alteração de Cadastro",
    ALTERACAO_ENDERECO: "Alteração de Endereço",
    TROCA_RAZAO_SOCIAL: "Troca de Razão Social",
    REATIVACAO: "Reativação",
};

const TIPO_PESSOA_LABELS = {
    PESSOA_FISICA: "Pessoa Física",
    PESSOA_JURIDICA: "Pessoa Jurídica",
};

const DIA_VISITA_LABELS = {
    SEGUNDA_FEIRA: "Segunda-feira",
    TERCA_FEIRA: "Terça-feira",
    QUARTA_FEIRA: "Quarta-feira",
    QUINTA_FEIRA: "Quinta-feira",
    SEXTA_FEIRA: "Sexta-feira",
    SABADO: "Sábado",
};

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheCadastroCliente({ detalheProcesso }) {
    if (!detalheProcesso) return null;
    const d = detalheProcesso;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Informações Gerais</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Tipo da Solicitação" valor={TIPO_SOLICITACAO_LABELS[d.tipoSolicitacao] || d.tipoSolicitacao} />
                    <Campo label="Filial" valor={d.filialNome} />
                    <Campo label="Código do Cliente" valor={d.clienteCodigo} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Dados Pessoais</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Nome do Cliente" valor={d.nomeCliente} />
                    <Campo label="Data de Nascimento" valor={formatarData(d.dataNascimento)} />
                    <Campo label="CPF" valor={d.cpf} />
                    <Campo label="Tipo de Pessoa" valor={TIPO_PESSOA_LABELS[d.tipoPessoa] || d.tipoPessoa} />
                    <Campo label="CNPJ" valor={d.cnpj} />
                    <Campo label="Situação Cadastral" valor={d.situacaoCadastral} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Dados Empresariais</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Razão Social" valor={d.razaoSocial} />
                    <Campo label="Nome Fantasia" valor={d.fantasia} />
                    <Campo label="Inscrição Estadual" valor={d.inscricaoEstadual} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Contato</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="E-mail" valor={d.email} />
                    <Campo label="Telefone I" valor={d.telefone1} />
                    <Campo label="Contato I" valor={d.nomeContato1} />
                    <Campo label="Telefone II" valor={d.telefone2} />
                    <Campo label="Contato II" valor={d.nomeContato2} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Endereço</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="CEP" valor={d.cep} />
                    <Campo label="Rua" valor={d.rua} />
                    <Campo label="Número" valor={d.numero} />
                    <Campo label="Bairro" valor={d.bairro} />
                    <Campo label="Cidade" valor={d.cidade} />
                    <Campo label="Estado" valor={d.estado} />
                    <Campo label="Complemento" valor={d.complemento} />
                    <Campo label="Ponto de Referência" valor={d.pontoReferencia} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Dados Complementares</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Estado Civil" valor={d.estadoCivil} />
                    <Campo label="Profissão" valor={d.profissao} />
                    <Campo label="SubCanal" valor={d.subCanalNome} />
                    <Campo label="Dia de Visita" valor={DIA_VISITA_LABELS[d.diaVisita] || d.diaVisita} />
                    <Campo label="Rota" valor={d.rota} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Equipamentos</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Possui equipamento" valor={d.possuiEquipamento ? "Sim" : "Não"} />
                    {d.possuiEquipamento && <Campo label="Quantidade de Equipamentos" valor={d.quantidadeEquipamentos} />}
                    <Campo label="Possui vasilhames" valor={d.possuiVasilhame ? "Sim" : "Não"} />
                    {d.possuiVasilhame && <Campo label="Quantidade de Vasilhames" valor={d.quantidadeVasilhames} />}
                </div>
            </div>

            {d.observacoes && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Observações</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{d.observacoes}</p>
                </div>
            )}

            {d.justificativaSupervisor && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (Supervisor)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{d.justificativaSupervisor}</p>
                </div>
            )}

            {temInformacaoFinanceira(d) && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Informações Financeiras</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Documentação completa" valor={campoSimNao(d.documentacaoCompleta)} />
                        <Campo label="Já possui cadastro?" valor={campoSimNao(d.jaPossuiCadastro)} />
                        <Campo label="Coordenadas cadastradas" valor={campoSimNao(d.coordenadasCadastradas)} />
                        <Campo label="Registro de Ligação" valor={formatarData(d.registroLigacao)} />
                        <Campo label="Novo Código Cliente" valor={d.novoCodigoCliente} />
                        <Campo label="Confirmação dados" valor={campoSimNao(d.confirmacaoDados)} />
                        <Campo label="Consultado no Boa Vista" valor={campoSimNao(d.consultadoBoaVista)} />
                        <Campo label="Consultado no Confirme" valor={campoSimNao(d.consultadoConfirme)} />
                        <Campo label="Consultado na Receita" valor={campoSimNao(d.consultadoReceita)} />
                    </div>
                    {d.observacoesFinanceiro && (
                        <p className="text-sm text-foreground whitespace-pre-wrap mt-3">{d.observacoesFinanceiro}</p>
                    )}
                </div>
            )}
        </div>
    );
}

function campoSimNao(valor) {
    if (valor === null || valor === undefined) return null;
    return valor ? "Sim" : "Não";
}

function temInformacaoFinanceira(d) {
    return [
        d.documentacaoCompleta, d.jaPossuiCadastro, d.coordenadasCadastradas, d.registroLigacao,
        d.novoCodigoCliente, d.confirmacaoDados, d.consultadoBoaVista, d.consultadoConfirme,
        d.consultadoReceita, d.observacoesFinanceiro,
    ].some(v => v !== null && v !== undefined && v !== "");
}
 